import * as T from '@radix-ui/react-tabs';
import * as React from 'react';
import { cn } from '../lib/cn';

/** `label` names the tab list for screen readers (two tab sets on one page need different names); an empty section can be
 * `disabled`; `compact` fits more tabs in a narrow panel. */
export function Tabs({ value, onValueChange, tabs, label = 'Sections', compact = false }: {
  value: string; onValueChange: (v: string) => void; tabs: Array<{ value: string; label: React.ReactNode; content: React.ReactNode; disabled?: boolean }>; label?: string; compact?: boolean;
}) {
  return (
    <T.Root value={value} onValueChange={onValueChange}>
      <T.List className={cn('flex overflow-x-auto border-b border-line', compact ? 'gap-0' : 'gap-1')} aria-label={label}>
        {tabs.map(t => (
          <T.Trigger key={t.value} value={t.value} disabled={t.disabled}
            className={cn('whitespace-nowrap border-b-2 border-transparent py-2 font-semibold', compact ? 'px-2 text-[13px]' : 'px-3 text-sm', 'text-ink-3 hover:text-ink disabled:cursor-default disabled:text-ink-3/50 disabled:hover:text-ink-3/50 data-[state=active]:border-tick data-[state=active]:text-ink')}>
            {t.label}
          </T.Trigger>
        ))}
      </T.List>
      {tabs.map(t => <T.Content key={t.value} value={t.value} className="pt-4 focus-visible:outline-none">{t.content}</T.Content>)}
    </T.Root>
  );
}
